import { search } from "algolia-instant-search";

const { connectInfiniteHits } = instantsearch.connectors;

if (!customElements.get("algolia-infinite-hits")) {
  class AlgoliaInfiniteHits extends HTMLElement {
    connectedCallback() {
      this.selectElements();

      const customInfiniteHits = connectInfiniteHits(
        this.renderInfiniteHits.bind(this),
      );

      search.addWidgets([
        customInfiniteHits({
          container: this.content,
        }),
      ]);
    }

    selectElements() {
      this.productCardTemplate = this.querySelector("template#product-card");
      this.loadMoreButtonTemplate = this.querySelector(
        "template#load-more-button",
      );
      this.content = this.querySelector("#main-product-grid");
    }

    renderInfiniteHits(renderOptions, isFirstRender) {
      const { hits, showMore, isLastPage, widgetParams, results } =
        renderOptions;

      if (isFirstRender) {
        // Create load more button from template
        const loadMoreClone =
          this.loadMoreButtonTemplate.content.cloneNode(true);
        widgetParams.container.parentNode.insertBefore(
          loadMoreClone,
          widgetParams.container.nextSibling,
        );

        // Get reference to the button and add click handler
        const loadMoreContainer =
          widgetParams.container.parentNode.querySelector(".ymm-paginate");
        const button = loadMoreContainer.querySelector(".jsLoadMore");

        button.addEventListener("click", () => {
          showMore();
        });

        widgetParams.loadMoreContainer = loadMoreContainer;
      }

      // Render all product cards
      widgetParams.container.innerHTML = "";

      hits.forEach((hit) => {
        const productCardClone =
          this.productCardTemplate.content.cloneNode(true);

        // Populate product data
        const handle = hit.handle || "";
        const imageUrl = hit.images?.[0].url ?? hit.featured_image?.url ?? "";

        const title = hit.title || hit.product_title || "";
        const sku = hit.sku || hit.variants?.[0]?.sku || "";
        const price = hit.price ? `$${hit.price.toFixed(2)}` : "";
        const isQuickShip = hit.metafield_quick_ship === "1";
        const isExpertPick = hit.metafield_expert_pick === "1";
        const comparePrice = hit.compare_at_price
          ? `$${hit.compare_at_price.toFixed(2)}`
          : "";
        const variantSelected = hit.variant_id
          ? `?variant=${hit.variant_id}`
          : "";
        const productUrl = `/products/${handle}${variantSelected}`;

        // Set product URL
        const productLinks =
          productCardClone.querySelectorAll("[data-product-url]");
        productLinks.forEach((link) => link.setAttribute("href", productUrl));

        const productTitleLink = productCardClone.querySelector(
          "[data-product-title-link]",
        );
        productTitleLink.setAttribute("href", productUrl);
        productTitleLink.textContent = title;

        const lazyScript = productCardClone.querySelector("lazy-script");
        lazyScript.setAttribute("data-url", productUrl);

        // Set product image
        const productImage = productCardClone.querySelector(
          "[data-product-image]",
        );
        productImage.setAttribute("src", imageUrl);
        productImage.setAttribute("alt", title);

        // Set SKU
        productCardClone.querySelector("[data-product-sku]").textContent = sku;

        // Set review stars and count from Algolia metafields
        const reviewsAverage = parseFloat(hit.metafield_reviews_average) || 0;
        const reviewsCount = hit.metafield_reviews_count || "0";
        const roundedAvg = Math.round(reviewsAverage);
        const fullStars = "★".repeat(roundedAvg);
        const emptyStars = "☆".repeat(5 - roundedAvg);

        const starsEl = productCardClone.querySelector("[data-review-stars]");
        const countEl = productCardClone.querySelector("[data-review-count]");
        starsEl.textContent = fullStars + emptyStars;
        countEl.textContent = `(${reviewsCount})`;
        countEl.setAttribute("role", "img");
        countEl.setAttribute(
          "aria-label",
          `${reviewsAverage} out 5 stars rating in total ${reviewsCount} reviews`,
        );
        countEl.setAttribute(
          "title",
          `${reviewsAverage} out 5 stars rating in total ${reviewsCount} reviews`,
        );

        // Set price
        productCardClone.querySelector("[data-product-price]").textContent =
          price;

        // Set compare price
        const comparePriceEl = productCardClone.querySelector(
          "[data-product-compare-price]",
        );
        if (comparePrice) {
          comparePriceEl.textContent = comparePrice;
        } else {
          comparePriceEl.remove();
        }

        // Quickship/expert pick badges
        if (!isQuickShip) {
          productCardClone.querySelector('[data-badge="quick-ship"]')?.remove();
        }

        if (!isExpertPick) {
          productCardClone.querySelector('[data-badge="expert-pick"]')?.remove();
        }

        widgetParams.container.appendChild(productCardClone);
      });

      // Update button visibility
      if (widgetParams.loadMoreContainer) {
        widgetParams.loadMoreContainer.style.display = isLastPage
          ? "none"
          : "block";
      }
    }
  }
  customElements.define("algolia-infinite-hits", AlgoliaInfiniteHits);
}
